import { atom } from 'jotai';

import type { ZuubPatientDetailDataV3 } from '../../@types/zuub/contracts';
import type { Appointment } from '../../react-query/useAppointments';

export const insuranceStatusFilterAtom = atom<string>('all');

// Atom to store the selected card filter
// Categories: all, active, noCoverage, confirmDetails, checkManually
export const selectedCardAtom = atom<
  'all' | 'active' | 'noCoverage' | 'confirmDetails' | 'checkManually'
>('active');

// Multi-select filter atoms for Payer and Insurance Status
export const selectedPayerFiltersAtom = atom<string[]>([]);
export const selectedInsuranceStatusFiltersAtom = atom<string[]>([]);

// Atom to store the currently selected plan based on dropdown selections
export const selectedPlanAtom = atom<ZuubPatientDetailDataV3 | null>(null);

// Atom to store the selected patient's appointment data for last treatments history
export const selectedPatientAppointmentAtom = atom<Appointment | null>(null);

// Atom to store the selected payer ID for the connect payers page
export const selectedPayerIdAtom = atom<number | null>(null);
